
//
// Structure of the Isobar state:
//
//     isobars: {
//         "isobar1": {
//             label: "isobar1",
//             tuple: [1, 2],
//             resonances: {
//                 "resonance1": {
//                     spin: 1,
//                     parity: 1
//                 },
//                 "resonance2": {
//                     spin: 1,
//                     parity: -1
//                 }
//             }
//         },
//         "isobar2": {
//             label: "isobar2",
//             tuple: [1, 2],
//             resonances: {
//                 "resonance1": {
//                     spin: 1,
//                     parity: 1
//                 },
//                 "resonance2": {
//                     spin: 1,
//                     parity: -1
//                 }
//             }
//         }
//     }
//


const IsobarReducer = (state = { isobars: {} }, action) => {
    switch (action.type) {
        case 'SET_ISOBAR':
            return { ...state, isobars: action.payload };
        case 'ADD_RESONANCE':
            return { ...state, isobars: 
                {
                    ...state.isobars,
                    [action.payload.isobar]: {
                        ...state.isobars[action.payload.isobar],
                        resonances: {
                            ...state.isobars[action.payload.isobar].resonances,
                            [action.payload.label]: {
                                name: action.payload.label,
                                tuple: action.payload.isobar,
                                spin: action.payload.spin,
                                parity: action.payload.parity
                            }
                        }
                    }
                }
            };
        default:
            return state;
    }
}

export default IsobarReducer;